import './resort.scss';
import 'slick-carousel';
export default () => {
	// Slick slider
	$( '.js-slider-for' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		rows: 0,
		dots: false,
		fade: true,
		asNavFor: '.js-slider-nav',
	} );
	$( '.js-slider-nav' ).slick( {
		slidesToShow: 4,
		slidesToScroll: 1,
		asNavFor: '.js-slider-for',
		centerPadding: '0',
		rows: 0,
		arrows: false,
		dots: false,
		centerMode: true,
		focusOnSelect: true,
		vertical: true,
		responsive: [ {
			breakpoint: 768,
			settings: {
				vertical: false,
			},
		} ],
	} );
};
